import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WordpressIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wordpress"}/>
}
